import React from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import LeftButton from "../LeftBtn/LeftBtn";
import "./ProductGalary.css";
import RightButton from "../RightBtn/RightBtn";
import { baseUrlImg } from "../../../Api/baseUrl";
import def from "../../../images/default-img.png";
const ProductGallery = ({ dataa }) => {
  return (
    <div
      className="product-gallary-card d-flex justfiy-content-center  align-items-center
        pt-2"
    >
      {dataa && dataa.id ? (
        <ImageGallery
          items={dataa.car_images.map((im) => ({
            original: baseUrlImg + im.image_url,
          }))}
          defaultImage={def}
          showFullscreenButton={false}
          isRTL={true}
          showPlayButton={false}
          showThumbnails={false}
          renderRightNav={RightButton}
          renderLeftNav={LeftButton}
        />
      ) : null}
      <hr/>

    </div>
  );
};

export default ProductGallery;
